<template v-if="href">
  <a-link-v2
    :url="href"
    :class="[name, `${name}__link`]"
    :scroll-to="`#${cms.scrollTo}`"
  >
    <a-svg-practice
      v-if="cms.practice"
      :cms="{
        practice: cms.practice,
      }"
      :class="`${name}__image`"
      copy="Read more."
      @mouseover.native="onPracticeHover(true)"
      @mouseleave.native="onPracticeHover(false)"
    />
    <a-image-v2
      v-else-if="(cms.image || {}).filename"
      :src="(cms.image || {}).filename"
      :alt="(cms.image || {}).alt"
      :class="`${name}__image`"
      :layout="[{ size: 0, bound: 206, ratio: [206, 206] }]"
      @mouseover.native="onPracticeHover(true)"
      @mouseleave.native="onPracticeHover(false)"
    />
  </a-link-v2>
</template>

<script>
import Href from '@/mixins/href'
import data from '~/components/molecules/m-cards/m-card-practice.data'
import ASvgPractice from '~/components/atoms/a-svgs/a-svg-practice'

export default {
  components: { ASvgPractice },
  mixins: [Href],
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'm-card-practice',
    }
  },
  methods: {
    onPracticeHover(boolean) {
      this.$emit('onPracticeHover', {
        active: boolean || false,
        heading: this.cms.heading,
        copy: this.cms.copy,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card-practice {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  overflow: hidden;
  max-width: 206px;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep .a-svg-practice svg {
    path {
      transition: fill 0.2s ease-in-out, color 0.2s ease-in-out,
        border 0.2s ease-in-out;
      fill: var(--text-color-logo);
    }
    rect {
      transition: fill 0.2s ease-in-out, color 0.2s ease-in-out,
        border 0.2s ease-in-out;
      fill: var(--bg-color-logo);
    }

    &:hover,
    &:active {
      path {
        fill: var(--hover-color-logo);
      }
      rect {
        fill: var(--hover-bg-color-logo);
      }
    }
  }
}
</style>
